<template>
    <div id="colorlib-page">
		<div id="colorlib-main" role="main">
			<div class="colorlib-blog">
				<div class="container-wrap">
					<div class="row">
						<div class="col-md-10">
                            <well-coach v-if="form_name=='well_coach'"></well-coach>
                            <feed-back v-if="form_name=='feed_back'"></feed-back>
                            <contact-counselor v-if="form_name=='contact_counselor'"></contact-counselor>
                            <contact-tobaccofree v-if="form_name=='contact_tobaccofree'"></contact-tobaccofree>
                            <contact-wellness v-if="form_name=='contact_wellness'"></contact-wellness>
                            <call-back v-if="form_name=='call_back'"></call-back>
                            <suggest-form v-if="form_name=='suggest_form'"></suggest-form>
                            <contact-coach v-if="form_name=='contact_coach'"></contact-coach>
                            <contact-counselor-new v-if="form_name=='contact_counselor_new'"></contact-counselor-new>
                            <lit-request v-if="form_name=='lit_request'"></lit-request>
                            <contact-wellness-company v-if="form_name=='contact_wellness_company'"></contact-wellness-company>
                            <contact-counselor-chn v-if="form_name=='contact_counselor_chn'"></contact-counselor-chn>
                            <call-back-case v-if="form_name=='callback_case'"></call-back-case>
                            <callbacks-link-select v-if="form_name=='callback_link_select'"></callbacks-link-select>
                            <callback-worklife-specialist v-if="form_name=='callback_work_life_specialist'"></callback-worklife-specialist>
                            <callback-worklife-specialist-chn v-if="form_name=='callback_work_life_specialist_chn'"></callback-worklife-specialist-chn>
						</div>						
					</div>
				</div>
			</div>
		</div>

	</div> 
</template>
<script>
import WellCoach from '@/components/ThemeMegazine/pages/forms/partials/WellCoach';
import FeedBack from '@/components/ThemeMegazine/pages/forms/partials/FeedBack';
import ContactCounselor from '@/components/ThemeMegazine/pages/forms/partials/ContactCounselor';
import ContactTobaccofree from '@/components/ThemeMegazine/pages/forms/partials/ContactTobaccofree';
import ContactWellness from '@/components/ThemeMegazine/pages/forms/partials/ContactWellness';
import CallBack from '@/components/ThemeMegazine/pages/forms/partials/CallBack';
import SuggestForm from '@/components/ThemeMegazine/pages/forms/partials/SuggestForm';
import ContactCoach from '@/components/ThemeMegazine/pages/forms/partials/ContactCoach';
import ContactCounselorNew from '@/components/ThemeMegazine/pages/forms/partials/ContactCounselorNew';
import LitRequest from '@/components/ThemeMegazine/pages/forms/partials/LitRequest';
import ContactWellnessCompany from '@/components/ThemeMegazine/pages/forms/partials/ContactWellnessCompany';
import ContactCounselorChn from '@/components/ThemeMegazine/pages/forms/partials/ContactCounselorChn';
import CallBackCase from '@/components/ThemeMegazine/pages/forms/partials/CallBackCase';
import CallbacksLinkSelect from '@/components/ThemeMegazine/pages/forms/partials/CallbacksLinkSelect';
import CallbackWorklifeSpecialist from '@/components/ThemeMegazine/pages/forms/partials/CallBackWorklifeSpecialist.vue';
import CallbackWorklifeSpecialistChn from '@/components/ThemeMegazine/pages/forms/partials/CallBackWorklifeSpecialistChn.vue';


export default {
    name: 'Body',
    data(){
        return{
            content_ld_flag:false,
            center_ld_flag:false,
            isActive: false,
            offcanvas: false,
            form_name:this.$route.params.form_name
        }        
    },
    components:{
        WellCoach,
        FeedBack,
        ContactCounselor,
        ContactTobaccofree,
        ContactWellness,
        CallBack,
        SuggestForm,
        ContactCoach,
        ContactCounselorNew,
        LitRequest,
        ContactWellnessCompany,
        ContactCounselorChn,
        CallBackCase,
        CallbacksLinkSelect,
        CallbackWorklifeSpecialist,
        CallbackWorklifeSpecialistChn
    },
    methods:{
        updateContentLdFlag() {
            this.content_ld_flag=true
        },
        updateCenterLdFlag() {
            this.center_ld_flag=true
        },
        toggleMegaMenuEvent: function(){	
			this.isActive=this.$refs.MainMenuRef.toggleMegaMenu(this.isActive)			
        }
         
    } 
};

</script>
<style scoped>
h2{color: #276d96c7;}
</style>
<style>
#fterms{
    width:25px !important;
    height:25px !important;
}
#fterms:focus{
    outline: 5px auto -webkit-focus-ring-color !important;
}
#colorlib-main{
    margin-left: auto !important;
    margin-right: auto !important;
    widows: 80% !important;
    float: unset !important;
}
@media screen and (max-width: 1200px) {
    #colorlib-main {
        width: 80% !important;
    }
}

</style>
